import { SequenceUploadReference } from '../models/sequence-upload-reference';

// Reads back a key built by `toSequenceParentKey`. Split on the last separator, not the first: the
// sequence id is always the trailing segment, whereas a client code could itself contain a colon.
export const parseSequenceParentKey = (sequenceParentKey: string): SequenceUploadReference => {
  const separatorIndex = sequenceParentKey.lastIndexOf(':');
  return {
    clientCode: sequenceParentKey.slice(0, separatorIndex),
    sequenceId: Number(sequenceParentKey.slice(separatorIndex + 1)),
  };
};
